import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Booking from "@/pages/Booking";
import GrowYourMind from "@/pages/GrowYourMind";
import CoachingResources from "@/pages/CoachingResources";
import Contact from "@/pages/Contact";
import Recruiting from "@/pages/Recruiting";
import Coaching from "@/pages/Coaching";
import Lifestyles from "@/pages/Lifestyles";
import RealEstate from "@/pages/RealEstate";
import TheBook from "@/pages/TheBook";
import Testimonials from "@/pages/Testimonials";
import ProducerCoaching from "@/pages/ProducerCoaching";
import VideoLibrary from "@/pages/VideoLibrary";
import MorningsAndRhythms from "@/pages/MorningsAndRhythms";
import Admin from "@/pages/Admin";
import LeadershipCoaching from "@/pages/LeadershipCoaching";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/leadership-coaching" element={<LeadershipCoaching />} />
            <Route path="/producer-coaching" element={<ProducerCoaching />} />
            <Route path="/lifestyles" element={<Lifestyles />} />
            <Route path="/lifestyles/mornings-and-rhythms" element={<MorningsAndRhythms />} />
            <Route path="/real-estate" element={<RealEstate />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/book" element={<TheBook />} />
            <Route path="/resources" element={<GrowYourMind />} />
            <Route path="/lifestyles/grow-your-mind" element={<GrowYourMind />} />
            <Route path="/coaching-resources" element={<CoachingResources />} />
            <Route path="/agent-portal/video-library" element={<VideoLibrary />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/join" element={<Recruiting />} />
            <Route path="/recruiting" element={<Recruiting />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
